export default __webpack_public_path__ + "static/media/attendance.a4776e5e.png";